var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"login-layout"},[_c('a-layout-content',{staticStyle:{"background":"#F2F2F2"}},[_c('router-view')],1),_c('Footer',{staticStyle:{"background":"rgb(242, 242, 242)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }